export const Columns = (openModalAdd, setModalConfirm, modalConfirm) => {
    return [
        {
            id: "plate",
            name: "PLATES",
            minWidth: "180px",
            cell: (row) => (
                <div className="flex flex-col gap-0.5 text-[9px] text-cs-dark">
                    {row.plate_usd && (
                        <span className="inline-flex items-center gap-1">
                            <span className="px-1.5 py-0.5 rounded-full bg-cs-bg-alt border border-cs-border text-[8px] text-cs-muted">
                                USA
                            </span>
                            <span className="font-medium">{row.plate_usd}</span>
                        </span>
                    )}
                    {row.plate_mx && (
                        <span className="inline-flex items-center gap-1">
                            <span className="px-1.5 py-0.5 rounded-full bg-cs-bg-alt border border-cs-border text-[8px] text-cs-muted">
                                MX
                            </span>
                            <span className="font-medium">{row.plate_mx}</span>
                        </span>
                    )}
                    {!row.plate_usd && !row.plate_mx && (
                        <span className="text-cs-muted">No plates</span>
                    )}
                </div>
            ),
        },
        {
            id: "number",
            name: "TRUCK NUMBER",
            minWidth: "120px",
            selector: (row) => row.number,
            cell: (row) => (
                <span className="text-[10px] font-semibold text-cs-dark">
                    {row.number || "-"}
                </span>
            ),
        },
        {
            id: "operator",
            name: "OPERATOR",
            minWidth: "150px",
            cell: (row) => {
                const name = row.operator?.name;
                return name ? (
                    <span className="px-2 py-0.5 rounded-full bg-cs-primary-soft text-cs-primary-dark text-[9px]">
                        {name}
                    </span>
                ) : (
                    <span className="text-[9px] text-cs-muted">
                        Not assigned
                    </span>
                );
            },
        },
        {
            id: "model",
            name: "MODEL",
            minWidth: "150px",
            cell: (row) => (
                <div className="flex flex-col leading-tight">
                    <span className="text-[10px] text-cs-dark">
                        {row.model?.name || "-"}
                    </span>
                    {row.model?.year && (
                        <span className="text-[8px] text-cs-muted">
                            {row.model.year}
                        </span>
                    )}
                </div>
            ),
        },
        {
            id: "fabricant",
            name: "FABRICANT",
            minWidth: "120px",
            cell: (row) => (
                <span className="text-[9px] text-cs-muted">
                    {row.model?.fabricant?.name || "-"}
                </span>
            ),
        },
        {
            id: "status",
            name: "STATUS",
            minWidth: "110px",
            cell: (row) => {
                const color = row.status?.color || "#6B7280";
                return (
                    <span
                        className="
                            px-2 py-0.5 rounded-full
                            text-[9px] font-medium text-white
                            inline-flex items-center gap-1
                        "
                        style={{ backgroundColor: color }}
                    >
                        <span className="w-1.5 h-1.5 rounded-full bg-white/90" />
                        {row.status?.name || "Unknown"}
                    </span>
                );
            },
        },
        {
            id: "actions",
            name: "",
            button: true,
            right: true,
            minWidth: "90px",
            cell: (row) => {
                const canDelete = !!row.can?.delete;
                return (
                    <div className="flex items-center justify-end gap-1.5">
                        {/* Edit */}
                        <button
                            type="button"
                            onClick={() => openModalAdd(row)}
                            className="
                                p-1.5 rounded-lg
                                text-cs-muted
                                hover:bg-cs-primary-soft
                                hover:text-cs-primary
                                transition-colors
                            "
                            title="Edit truck"
                        >
                            <span className="material-symbols-outlined text-[16px]">
                                edit
                            </span>
                        </button>
                        {/* Delete */}
                        <button
                            type="button"
                            onClick={() =>
                                setModalConfirm({
                                    ...modalConfirm,
                                    show: true,
                                    id: row.id,
                                })
                            }
                            disabled={!canDelete}
                            className={`
                                p-1.5 rounded-lg
                                transition-colors
                                ${
                                    canDelete
                                        ? "text-cs-danger hover:bg-cs-danger/5"
                                        : "text-cs-muted opacity-40 cursor-not-allowed"
                                }
                            `}
                            title={
                                canDelete ? "Delete truck" : "You cannot delete this unit"
                            }
                        >
                            <span className="material-symbols-outlined text-[16px]">
                                delete
                            </span>
                        </button>
                    </div>
                );
            },
        },
    ];
};

export const ColumnsTrailer = (
    openModalAdd,
    setModalConfirm,
    modalConfirm
) => {
    return [
        {
            id: "plate",
            name: "PLATES",
            minWidth: "180px",
            cell: (row) => (
                <div className="flex flex-col gap-0.5 text-[9px] text-cs-dark">
                    {row.plate_usd && (
                        <span className="inline-flex items-center gap-1">
                            <span className="px-1.5 py-0.5 rounded-full bg-cs-bg-alt border border-cs-border text-[8px] text-cs-muted">
                                USA
                            </span>
                            <span className="font-medium">{row.plate_usd}</span>
                        </span>
                    )}
                    {row.plate_mx && (
                        <span className="inline-flex items-center gap-1">
                            <span className="px-1.5 py-0.5 rounded-full bg-cs-bg-alt border border-cs-border text-[8px] text-cs-muted">
                                MX
                            </span>
                            <span className="font-medium">{row.plate_mx}</span>
                        </span>
                    )}
                    {!row.plate_usd && !row.plate_mx && (
                        <span className="text-cs-muted">No plates</span>
                    )}
                </div>
            ),
        },
        {
            id: "vin",
            name: "VIN NUMBER",
            minWidth: "150px",
            cell: (row) => (
                <span className="text-[10px] font-medium text-cs-dark">
                    {row.vin || "-"}
                </span>
            ),
        },
        {
            id: "type",
            name: "TYPE",
            minWidth: "120px",
            cell: (row) => (
                <span className="text-[9px] text-cs-muted">
                    {row.type?.name || "-"}
                </span>
            ),
        },
        {
            id: "model",
            name: "MODEL",
            minWidth: "140px",
            cell: (row) => (
                <span className="text-[9px] text-cs-dark">
                    {row.model?.name || "-"}
                </span>
            ),
        },
        {
            id: "fabricant",
            name: "FABRICANT",
            minWidth: "120px",
            cell: (row) => (
                <span className="text-[9px] text-cs-muted">
                    {row.model?.fabricant?.name || "-"}
                </span>
            ),
        },
        {
            id: "status",
            name: "STATUS",
            minWidth: "110px",
            cell: (row) => {
                const color = row.status?.color || "#6B7280";
                return (
                    <span
                        className="
                            px-2 py-0.5 rounded-full
                            text-[9px] font-medium text-white
                            inline-flex items-center gap-1
                        "
                        style={{ backgroundColor: color }}
                    >
                        <span className="w-1.5 h-1.5 rounded-full bg-white/90" />
                        {row.status?.name || "Unknown"}
                    </span>
                );
            },
        },
        {
            id: "actions",
            name: "",
            button: true,
            right: true,
            minWidth: "90px",
            cell: (row) => {
                const canDelete = !!row.can?.delete;
                return (
                    <div className="flex items-center justify-end gap-1.5">
                        {/* Edit */}
                        <button
                            type="button"
                            onClick={() => openModalAdd(row)}
                            className="
                                p-1.5 rounded-lg
                                text-cs-muted
                                hover:bg-cs-primary-soft
                                hover:text-cs-primary
                                transition-colors
                            "
                            title="Edit trailer"
                        >
                            <span className="material-symbols-outlined text-[16px]">
                                edit
                            </span>
                        </button>
                        {/* Delete */}
                        <button
                            type="button"
                            onClick={() =>
                                setModalConfirm({
                                    ...modalConfirm,
                                    show: true,
                                    id: row.id,
                                })
                            }
                            disabled={!canDelete}
                            className={`
                                p-1.5 rounded-lg
                                transition-colors
                                ${
                                    canDelete
                                        ? "text-cs-danger hover:bg-cs-danger/5"
                                        : "text-cs-muted opacity-40 cursor-not-allowed"
                                }
                            `}
                            title={
                                canDelete
                                    ? "Delete trailer"
                                    : "You cannot delete this unit"
                            }
                        >
                            <span className="material-symbols-outlined text-[16px]">
                                delete
                            </span>
                        </button>
                    </div>
                );
            },
        },
    ];
};
